


















































































































































































import { Component, Watch } from 'vue-property-decorator';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import FiltrosBusqueda from '@/pantallas/Camaras/Alertas/FiltrosBusqueda.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import WidgetAlerta from '@/pantallas/Camaras/Alertas/WidgetAlerta.vue';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import { actionsEvent } from '@/setup';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import moment from 'moment';
import showImage from '@/pantallas/Camaras/Alertas/showImage.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import VerEditarModal from './VerEditarModal.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    GridComponent: AgGridVue,
    FiltrosBusqueda,
    WidgetAlerta,
    showImage,
    FormFieldsContainer,
    DatePicker,
    VerEditarModal,
  },
})
export default class InventarioSimBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades = Funcionalidades.SimRegistros;
  mostrarModalVerDetalle: boolean = false;
  loadingService = new LoadingService();
  filtrobusquedagrilla: string = '';
  filtro: any;

  //MsResponseData: MsResponseData = null;
  //MsResponseDataWidget: MsResponseDataWidget = null;
  reporteSeleccionado: Number = null;
  serieNumeroSeleccionado: any[] = [];
  simestadolistSeleccionado: string = null;
  serieactivanroSeleccionado: string = null;
  showReporteGenerado: boolean = false;
  tipoeqid: any = '';
  pagina: number = 1;
  pagina_anterior = 1;
  columnApi: any = null;
  gridEvent: any = null;
  serverSide: any;
  gridApi: GridApi = null;
  texto_reporte: string = '';
  ordesList: any[] = [];
  telconamelist: any[] = [];
  telcoplannamelist: any[] = [];
  tiposim: any[] = [];
  simestadolist: any[] = [];
  racklist: any[] = [];
  bloquelist: any[] = [];
  crm_rutlist: any = [];
  ubicacionlist: any = [];
  estadolist: any = [];
  showModalMostrar: boolean = false;
  usuarioID: any = '';
  hashpaginacion: string = '';
  rowcount: number = 0;
  total_registros: number = 0;
  cant_regs_pag: number = 50;
  dateCargaInicio: any = moment()
    .subtract(1, 'month')
    .startOf('day');
  dateCargaFinal: any = moment().endOf('day');
  gridOptions: GridOptions;
  formFields: FormFieldDefMap;
  constructor() {
    super();
    actionsEvent.onEditar(this.handleVerDetalleClick);
    this.gridOptions = {
      columnDefs: [
        {
          headerName: 'Sim Número',
          field: 'simserienumero',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 140,
        },
        {
          headerName: 'Telco',
          field: 'telconame',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },

        {
          headerName: 'Plan',
          field: 'telcoplanname',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Tamaño',
          field: 'simtamanio',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Tipo SIM',
          field: 'tiposimname',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'APN',
          field: 'simapn',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Prefijo',
          field: 'simprefijo',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Número',
          field: 'simmovil',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'SIM Estado',
          field: 'configvalor',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Equipo Serie',
          field: 'serienumero',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Tipo de Equipo',
          field: 'tipoeqname',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Plataforma',
          field: 'plataforma',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
        },
        {
          headerName: 'Fecha De Carga',
          field: 'simingresofecha_alta',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
          valueFormatter: this.dateFormatter,
        },

        {
          headerName: 'Plataforma Estado',
          field: 'serieactivaplata_ingresada',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 135,
          cellRenderer: params => {
            if (!params.value) return '';
            if (params.data.serieactivaplata_ingresada == 'S') {
              var html = '<input type="checkbox" checked disabled>';
              return html;
            } else {
              return '<input type="checkbox" disabled>';
            }
          },
        },
        {
          headerName: 'Ubicación',
          field: 'tipoubicaname',
          cellStyle: { textAlign: 'left' },
          resizable: true,
          width: 215,
        },
      ],

      pagination: true,
      domLayout: 'autoHeight',
      paginationPageSize: 50,
      cacheBlockSize: this.cant_regs_pag,
      paginationAutoPageSize: false,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onGridReady: this.handleGridReady,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
    };

    this.formFields = {
      ubicacion: {
        label: 'Ubicación',
        id: '',
        value: '',
      },
      telco: {
        label: 'Telco',
        id: '',
        value: '',
      },
      telcoplan: {
        label: 'Telco Plan',
        id: '',
        value: '',
      },
      simestado: {
        label: 'Estado SIM',
        id: '',
        value: '',
      },
      simnumero: {
        label: 'SIM Serie Número',
        id: '',
        value: '',
      },
      serienumero: {
        label: 'Equipo Serie Número',
        id: '',
        value: '',
      },
      tipoSIM: {
        label: 'Tipo SIM',
        id: '',
        value: '',
      },
      dateCargaInicio: {
        label: 'Fecha Carga inicio',
        id: '',
        value: moment()
          .subtract(1, 'month')
          .startOf('day'),
      },
      dateCargaFinal: {
        label: 'Fecha Carga Fin',
        id: '',
        value: moment().endOf('day'),
      },
    };
  }
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_inventario_sim/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.ubicacionlist = data.data.UBICACION;
          self.telconamelist = data.data.TELCONAME;
          self.telcoplannamelist = data.data.TELCOPLANNAME;
          self.simestadolist = data.data.SIMESTADO;
          self.tiposim = data.data.TIPO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  dateFormatter(params: any) {
    return params && params.movifecha_recibe != ''
      ? moment(params.value).format('YYYY-MM-DD HH:mm:ss')
      : '';
  }

  async handleGridReady(event: GridReadyEvent) {
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    this.gridApi = event.api;
    this.gridApi.setDomLayout('autoHeight');

    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.usuarioID = JSON.parse(localStorage.getItem('user')).id;
    let self = this;
    this.serverSide = {
      getRows(event: any): void {
        event.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.pagina = Math.ceil(
          event.request.startRow / self.cant_regs_pag + 1
        );
        let body: any = self.filtros2body();
        body.pagina = self.pagina;
        fetchReportesSerie(
          {
            simestado: body.simestado,
            ubicacion: body.ubicacion,
            telconame: body.telconame,
            telco: body.telco,
            pagina: body.pagina,
            simnumero: body.simnumero,
            serienumero: body.serienumero,
            tiposimid: body.tiposimid,
            dateCargaInicio: body.dateCargaInicio,
            dateCargaFinal: body.dateCargaFinal,
            total_registros: self.total_registros,
            cambio_pagia: self.pagina_anterior != self.pagina ? 1 : 0,
          },
          'conecta_inventario_sim/get_filtered_rs'
        )
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              if (response.data.data.length === 0) {
                event.successCallback([{}], 0);
                self.gridApi.showNoRowsOverlay();
                self.$snotify.error('Sin registros', { timeout: 3000 });
              } else {
                console.log(response.data.data);
                event.successCallback(
                  response.data.data.LISTA,
                  Number(response.data.cant_regs_pag.TOTAL_REGISTROS)
                );
                self.gridApi.hideOverlay();
                self.autoSizeAll(true);
                self.total_registros =
                  response.data.cant_regs_pag.TOTAL_REGISTROS;
                self.pagina_anterior = self.pagina;
              }
            } else {
              event.successCallback([{}], 0);
              self.total_registros = 0;
              self.$snotify.error(response.data.MENSAJE_RESPUESTA, {
                timeout: 3000,
              });
            }
          })
          .catch((error: any) => {
            event.successCallback([{}], 0);
            self.$snotify.error('Ocurrió un error. Intente nuevamente.', {
              timeout: 3000,
            });
          })
          .finally(() => {
            self.gridApi.setDomLayout('autoHeight');
          });
      },
    };
    this.getEquipos();
    this.clearFilters();
    this.filtroRequerimiento(true);
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }
  handleBuscarClick() {
    this.pagina_anterior = 1;
    this.filtroRequerimiento(true);
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }
  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }
  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }
  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;

    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }
  async clearFilters() {
    this.formFields.ubicacion.value = undefined;
    this.formFields.telco.value = undefined;
    this.formFields.telcoplan.value = undefined;
    this.formFields.simestado.value = undefined;
    this.formFields.simnumero.value = undefined;
    this.formFields.serienumero.value = undefined;
    this.formFields.dateCargaInicio.value = moment()
      .subtract(1, 'month')
      .startOf('day');
    this.formFields.dateCargaFinal.value = moment().endOf('day');
    this.filtroRequerimiento(true);
  }

  //evita el click derecho
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }

  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: true,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionExportar,
  ];

  filtroRequerimiento(loadWidget: boolean) {
    this.gridApi.setServerSideDatasource(this.serverSide);
  }
  async fetchRequermientosWidgets() {
    this.loadingService.showLoading();
  }
  filtros2body() {
    let body: any = {};
    body.ubicacion = this.formFields.ubicacion.value
      ? this.formFields.ubicacion.value
      : '';
    body.telconame = this.formFields.telco.value
      ? this.formFields.telco.value
      : '';
    body.telco = this.formFields.telcoplan.value
      ? this.formFields.telcoplan.value
      : '';
    body.simestado = this.formFields.simestado.value
      ? this.formFields.simestado.value
      : '';
    body.simnumero = this.formFields.simnumero.value
      ? this.formFields.simnumero.value
      : '';
    body.serienumero = this.formFields.serienumero.value
      ? this.formFields.serienumero.value
      : '';
    body.tiposimid = this.formFields.tipoSIM.value
      ? this.formFields.tipoSIM.value
      : '';
    body.dateCargaInicio =
      moment(this.formFields.dateCargaInicio.value.toString())
        .startOf('day')
        .format('YYYY-MM-DD HH:mm') || '';
    body.dateCargaFinal =
      moment(this.formFields.dateCargaFinal.value.toString())
        .endOf('day')
        .format('YYYY-MM-DD HH:mm') || '';
    return body;
  }
  async btn_exportar() {
    let body: any = this.filtros2body();
    (body.extension = 'csv'),
      this.loadingService.showLoading(undefined, 'btn_exportar');
    return fetchReportesSerie(
      {
        body: body,
        clienteDefecto: JSON.parse(localStorage.getItem('user')).clienteDefecto,
        user_id: JSON.parse(localStorage.getItem('user')).id,
        tipo_alerta: 'CONECTA_REPORTES_SERIE',
      },
      'conecta_inventario_sim/exportar'
    )
      .then((data: any) => {
        this.showReporteGenerado = true;
        this.loadingService.hideLoading('btn_exportar');
        this.texto_reporte = data.data.MENSAJE_RESPUESTA;

        return data.data;
      })
      .catch((error: any) => {
        return null;
      })
      .finally(() => {
        return null;
      });
  }
  closeReporte() {
    this.showReporteGenerado = false;
    this.texto_reporte = '';
  }
  handleVerDetalleClick(params: ICellRendererParams) {
    this.serieNumeroSeleccionado = params.data.simserienumero;
    /*     this.simestadolistSeleccionado = this.simestadolist */
    this.mostrarModalVerDetalle = true;
  }
  handleCierreModalVerDetalle() {
    this.mostrarModalVerDetalle = false;
    this.handleBuscarClick();
  }

  searchData() {
    this.gridApi.setQuickFilter(this.filtrobusquedagrilla);
    this.gridApi.setDomLayout('autoHeight');
  }
  getPlanOptions() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { telcoid: this.formFields.telco.value },
      'conecta_inventario_sim/tomar_plan'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.telcoplannamelist = data.data.TELCOPLANNAME;
        } else {
          return;
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
}
